"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolSurvey = exports.SchoolPlumbingProfile = exports.PlumbingProfileType = void 0;
var Base_1 = require("./../Base");
var PlumbingProfileType;
(function (PlumbingProfileType) {
    PlumbingProfileType[PlumbingProfileType["PlumbingNetworkMaterial"] = 0] = "PlumbingNetworkMaterial";
    PlumbingProfileType[PlumbingProfileType["ServiceConnectionMaterial"] = 1] = "ServiceConnectionMaterial";
})(PlumbingProfileType = exports.PlumbingProfileType || (exports.PlumbingProfileType = {}));
var SchoolPlumbingProfile = /** @class */ (function (_super) {
    __extends(SchoolPlumbingProfile, _super);
    function SchoolPlumbingProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SchoolPlumbingProfile;
}(Base_1.BaseModel));
exports.SchoolPlumbingProfile = SchoolPlumbingProfile;
// tslint:disable-next-line:max-classes-per-file
var SchoolSurvey = /** @class */ (function (_super) {
    __extends(SchoolSurvey, _super);
    function SchoolSurvey() {
        return _super.call(this) || this;
    }
    return SchoolSurvey;
}(Base_1.BaseModel));
exports.SchoolSurvey = SchoolSurvey;
//# sourceMappingURL=SchoolSurvey.js.map